'use es6';

import { createSelector } from 'reselect';
import { getEvent, getShouldAutoSubmit } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getStagedFormFieldValidation, getInitialFormFieldValidation, getFormFieldValidation } from 'MeetingsLib/selectors/FormFieldValidationSelector';
import { getAllRequiredConsentCollected } from './LegalConsentFormSelectors';
import get from 'transmute/get';
var forcePropertyFormIfInitialFormComplete = get('forcePropertyForm');

var checkAllFormValidation = function checkAllFormValidation(formStateValidation) {
  if (!formStateValidation) {
    return false;
  }

  var customFieldsInvalid = formStateValidation.get('customFormFields').filter(function (fieldValidation) {
    return Boolean(fieldValidation);
  }).size > 0;
  var isEmailInvalid = Boolean(formStateValidation.get('email'));
  var isFirstNameInvalid = Boolean(formStateValidation.get('firstName'));
  var isLastNameInvalid = Boolean(formStateValidation.get('lastName'));
  return !(customFieldsInvalid || isEmailInvalid || isFirstNameInvalid || isLastNameInvalid);
};

export var canSubmitInitialPropertyForm = createSelector([getInitialFormFieldValidation, forcePropertyFormIfInitialFormComplete, getShouldAutoSubmit], function (formFieldValidation, forcePropertyForm, shouldAutoSubmit) {
  return (forcePropertyForm === false || shouldAutoSubmit) && checkAllFormValidation(formFieldValidation);
});
export var canSubmitStagedPropertyForm = createSelector([getStagedFormFieldValidation], checkAllFormValidation);
export var canSubmitPropertyForm = createSelector([getFormFieldValidation], checkAllFormValidation);
export var canSubmitMeetingTime = createSelector([getEvent], function (event) {
  return Boolean(event.dateTime);
});
export var canSubmitBooking = createSelector([canSubmitMeetingTime, canSubmitPropertyForm, getAllRequiredConsentCollected], function (meetingTimeValid, propertyFormValid, legalConsentValid) {
  return meetingTimeValid && propertyFormValid && legalConsentValid;
});